import Joi from "@hapi/joi";

export default {
    company: {
        name: {
            defaultValue: "",
            validation: Joi.string()
                .label("Firmenname"),
            render: {
                type: "input",
                configuration: {
                    label: "Firmenname"
                }
            }
        },
        firstname: {
            defaultValue: "",
            validation: Joi.string()
                .label("Vorname"),
            render: {
                type: "input",
                configuration: {
                    label: "Vorname"
                }
            }
        },
        surname: {
            defaultValue: "",
            validation: Joi.string()
                .label("Nachname"),
            render: {
                type: "input",
                configuration: {
                    label: "Nachname"
                }
            }
        },
        email: {
            defaultValue: "",
            validation: Joi.string()
                .label("Email"),
            render: {
                type: "input",
                configuration: {
                    label: "Email"
                }
            }
        }
    }
}
